import {
  ORDER_TRANSACTION_DOC_NUMBER_FILTER,
  ORDER_TRANSACTION_DOC_NUMBER_INV_FILTER,
  ORDER_TRANSACTION_DOC_NUMBER_REF_FILTER,
  ORDER_TRANSACTION_SHOW_ONLY_LAST_REF,
  ORDER_TRANSACTION_SHIP_START_DATE_FILTER,
  ORDER_TRANSACTION_SHIP_TO_DATE_FILTER,
} from "constants/ActionTypes";

const initialState = {
  docNumberFilter: "",
  docNumberInvFilter: "",
  docNumberRefFilter: "",
  showOnlyLastRefFilter: false,
  // ช่วงวันที่จัดส่ง — ตั้งต้นว่างไว้ = ไม่กรอง ShipDate (ต่างจากช่วงวันที่เอกสาร
  // ที่ตั้งต้นเป็นวันนี้ถึงวันนี้ใน reducers/Main.js)
  shipStartDateFilter: "",
  shipToDateFilter: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ORDER_TRANSACTION_DOC_NUMBER_FILTER:
      return {
        ...state,
        docNumberFilter: action.payload,
      };
    case ORDER_TRANSACTION_DOC_NUMBER_INV_FILTER:
      return {
        ...state,
        docNumberInvFilter: action.payload,
      };
    case ORDER_TRANSACTION_DOC_NUMBER_REF_FILTER:
      return {
        ...state,
        docNumberRefFilter: action.payload,
      };
    case ORDER_TRANSACTION_SHOW_ONLY_LAST_REF:
      return {
        ...state,
        showOnlyLastRefFilter: action.payload,
      };
    case ORDER_TRANSACTION_SHIP_START_DATE_FILTER:
      return {
        ...state,
        shipStartDateFilter: action.payload,
      };
    case ORDER_TRANSACTION_SHIP_TO_DATE_FILTER:
      return {
        ...state,
        shipToDateFilter: action.payload,
      };
    default:
      return state;
  }
};
